module.exports = __webpack_public_path__ + "static/media/bg2-6.e036d6b2.jpg";